/*
Controller: Promotions

Operations:
  getPromotions
  createPromotion
  getPromotion
  updatePromotion
*/
var Api = require('../config')
var PromotionDef = require('../definitions/Promotion')

var Promotions = (function () {
  /*
  Operation: getPromotions
  Query existing promotions
  Parameters:
    promoTitle: Promotions Title

    status: filter by status, possible values: &#39;active&#39;, &#39;past&#39;, &#39;scheduled&#39;
    page: page number, starting with 1
    perPage: number of items per page, max 50
    sortBy: field to sort by, possible values: &#39;startDate&#39;,&#39;endDate&#39;,&#39;duration&#39;,&#39;promoTitle&#39;,&#39;discount&#39;
    sortDirection: direction to sort by, asc or desc
  Responses:
    HTTP 200: List of promotions
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getPromotionsPromotions (promoTitle, active, status, page, perPage, sortBy, sortDirection) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['promoTitle'] = promoTitle
      parameters['active'] = active
      parameters['status'] = status
      parameters['page'] = page
      parameters['perPage'] = perPage
      parameters['sortBy'] = sortBy
      parameters['sortDirection'] = sortDirection
      var path = '/promotions'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createPromotion
  Create Promotion
  Parameters:
    bodyRequest: Promotion object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Promotion creation failed
    HTTP 403: Operation not permitted
  */
  function createPromotionPromotions (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        PromotionDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/promotions'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getPromotion
  Query existing promotion details
  Parameters:
    promotionId: Promotions Id
  Responses:
    HTTP 200: promotion details
    HTTP 400: Promotion update failed
    HTTP 403: Operation not permitted
    HTTP 404: Promotion not found
  */
  function getPromotionPromotions (promotionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!promotionId) {
          throw new Error('promotionId: Missing parameter')
        }
        if (promotionId && !(typeof promotionId === 'string')) {
          throw new Error('promotionId: Wrong type: Got "' + (typeof promotionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/promotions/{promotionId}'
      path = path.replace('{' + 'promotionId' + '}', promotionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updatePromotion
  Update Promotion
  Parameters:
    promotionId: Promotions Id
    bodyRequest: Promotion object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Promotion creation failed
    HTTP 403: Operation not permitted
    HTTP 404: Promotion not found
  */
  function updatePromotionPromotions (promotionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!promotionId) {
          throw new Error('promotionId: Missing parameter')
        }
        if (promotionId && !(typeof promotionId === 'string')) {
          throw new Error('promotionId: Wrong type: Got "' + (typeof promotionId) + '", but expected: "string"')
        }
        PromotionDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/promotions/{promotionId}'
      path = path.replace('{' + 'promotionId' + '}', promotionId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getPromotions'] = getPromotionsPromotions
  ret['createPromotion'] = createPromotionPromotions
  ret['getPromotion'] = getPromotionPromotions
  ret['updatePromotion'] = updatePromotionPromotions
  return ret
})()

module.exports = Promotions
